"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const pulse_components_1 = require("@pcs/pulse-components");
const react_redux_1 = require("react-redux");
const clsx_1 = __importDefault(require("clsx"));
const helper_1 = require("../../../../reviews/helper");
const store_1 = require("../../../store");
const selectors_1 = __importDefault(require("../../../slice/selectors"));
const sliceReview_1 = require("../../../slice/sliceReview");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const ReviewWebsite = () => {
    const { url, historyPhases } = (0, react_redux_1.useSelector)(selectors_1.default);
    const { urls, combineProof, type } = url;
    const dispatch = (0, store_1.useDocumentReviewDispatch)();
    const dispatchUrl = (payloadUrl) => {
        dispatch((0, sliceReview_1.updateUrl)({ ...payloadUrl }));
    };
    const handleCombine = (e) => {
        const { checked } = e === null || e === void 0 ? void 0 : e.target;
        dispatchUrl({
            ...url,
            combineProof: checked,
        });
    };
    const handleChangeInput = (event, urlIndex) => {
        const { value } = event === null || event === void 0 ? void 0 : event.target;
        const newUrls = [...urls];
        if (urlIndex >= 0) {
            newUrls[urlIndex] = value;
        }
        dispatchUrl({
            ...url,
            urls: newUrls,
            isValid: newUrls.every((item) => (0, helper_1.isReviewUrl)(item)),
        });
    };
    const handleAddUrl = () => {
        dispatchUrl({
            ...url,
            urls: [...url.urls, ''],
        });
    };
    const handleRemoveUrl = (urlIndex) => {
        const newUrls = [...urls];
        if (newUrls.length > 1) {
            newUrls.splice(urlIndex, 1);
            dispatchUrl({
                ...url,
                urls: newUrls,
            });
        }
    };
    const isValidInputUrl = (listUrl, index) => {
        return ((0, helper_1.getIndexUrlDuplicates)(listUrl).includes(index) ||
            !(0, helper_1.isReviewUrl)(listUrl[index]));
    };
    const handleTypeUrl = (isDynamicWebsite = false) => {
        dispatch((0, sliceReview_1.updateTypeUrl)(isDynamicWebsite));
    };
    (0, react_1.useEffect)(() => {
        if (!url.urls.every((item) => (0, helper_1.isReviewUrl)(item))) {
            dispatch((0, sliceReview_1.disableNextBtn)());
        }
        else {
            dispatch((0, sliceReview_1.enableNextBtn)());
        }
    }, [url]);
    return (react_1.default.createElement("section", { className: styles_modules_less_1.default['review-website__root'] },
        react_1.default.createElement("span", { className: styles_modules_less_1.default['review-website__label'] }, "Enter web address for review"),
        react_1.default.createElement("div", { className: styles_modules_less_1.default['review-website__urls'] },
            urls.map((urlWebsite, index) => (react_1.default.createElement("div", { key: index, className: styles_modules_less_1.default['review-website__url'] },
                react_1.default.createElement("div", { className: styles_modules_less_1.default['url-input__root'] },
                    react_1.default.createElement(pulse_components_1.PulseInput, { classes: {
                            root: (0, clsx_1.default)(styles_modules_less_1.default['url-input__bg']),
                        }, InputBaseProps: {
                            classes: {
                                input: (0, clsx_1.default)(styles_modules_less_1.default['url-input__base'], 
                                // make sure requirement is fired when this string isn't url or it's duplicating with urls
                                !url.isValid && isValidInputUrl(urls, index)
                                    ? styles_modules_less_1.default['url-input__base--isInvalid']
                                    : styles_modules_less_1.default['url-input__base']),
                            },
                            placeholder: 'Enter url of website to review',
                            value: urlWebsite,
                            onChange: (event) => handleChangeInput(event, index),
                        } })),
                react_1.default.createElement("i", { onClick: () => handleRemoveUrl(index), className: (0, clsx_1.default)(styles_modules_less_1.default['url-input__remove-icon'], urls.length <= 1 && styles_modules_less_1.default['url-input__remove-icon--hide'], 'fal fa-times') })))),
            !url.isValid && (react_1.default.createElement("span", { className: styles_modules_less_1.default.urls__invalid }, "Invalid URL"))),
        react_1.default.createElement("div", { className: styles_modules_less_1.default['review-website__controller'] },
            react_1.default.createElement("div", { className: styles_modules_less_1.default['controller-combine'] }, urls.length > 1 && (react_1.default.createElement(pulse_components_1.PulseCheckBox, { onClick: handleCombine, checked: combineProof, label: "Combine Proofs", labelPlacement: "right", showLabel: true, className: [styles_modules_less_1.default['controller-combine__icon']], labelClasses: styles_modules_less_1.default['controller-combine__label'] }))),
            react_1.default.createElement("div", { className: styles_modules_less_1.default['controller-typeOptions'] },
                react_1.default.createElement(pulse_components_1.PulseCheckBox, { onClick: () => handleTypeUrl(), checked: !!(type === 'web-static'), label: "Take a Snapshot", labelPlacement: "right", showLabel: true, className: [styles_modules_less_1.default['controller-typeOptions__icon']], labelClasses: styles_modules_less_1.default['controller-typeOptions__label'] }),
                react_1.default.createElement(pulse_components_1.PulseCheckBox, { onClick: () => handleTypeUrl(true), checked: !!(type === 'web-dynamic'), label: "View Live Content", labelPlacement: "right", showLabel: true, className: [styles_modules_less_1.default['controller-typeOptions__icon']], labelClasses: styles_modules_less_1.default['controller-typeOptions__label'] })))));
};
exports.default = ReviewWebsite;
